const ZaiUserStatus = {
  Active: 'Active',
  InActive: 'InActive',
};

export default ZaiUserStatus;
